import React from 'react';

/**
 * @function Container
 * @param {JSX.Element} children
 * @return {JSX.Element}
 * @constructor
 */
const Container = ({children, size = "max-w-7xl"}) => {
    return (
        <div className={`mx-auto px-2 sm:px-4 lg:px-8 py-4 ${size}`}>
            {children}
        </div>
    );
}

export default Container;
